// extracted by mini-css-extract-plugin
export default {"firstPrice":"GDsfl","additionalPrice":"jLlcM","priceLabel":"Ub003","fieldClassName":"Ilo0D"};